// src/lib/salepage/uploadSlip.ts
// อัปโหลดสลิปจาก "หน้าที่ลูกค้าใช้" (เซลเพจ / custom domain)
//
// ⚠️ ห้ามใช้ /api/upload ในหน้าฝั่งลูกค้าเด็ดขาด — endpoint นั้นเรียก
// requireApiUser ผู้ซื้อจริงไม่ได้ล็อกอิน seaaii จึงได้ 401 "Unauthorized"
// แล้ว **ออเดอร์ไม่ถูกสร้างเลย** (ทั้ง 2 หน้า return ทันทีเมื่ออัปสลิปไม่ผ่าน)
// ร้านมองไม่เห็นอะไรเลยเพราะไม่มีออเดอร์ค้างให้เห็นด้วยซ้ำ
//
// อาการหลอกมาก: เจ้าของร้านเทสต์เองแล้วผ่าน เพราะล็อกอินหลังบ้านอยู่ —
// พังเฉพาะผู้ซื้อจริง
//
// บั๊กนี้เคยแก้ไปแล้วรอบหนึ่งที่หน้า checkout แยกหน้า (dbbc9415) แต่ตกหน้า
// InlineCheckout (ฟอร์มที่ฝังในเซลเพจ + ใช้กับ custom domain) ไว้ จึงย้ายมา
// เป็นฟังก์ชันกลางให้เหลือที่เดียวที่ต้องถูก

export interface SlipUploadResult {
  url?: string;
  error?: string;
}

/**
 * อัปสลิปขึ้น R2 ผ่าน endpoint สาธารณะ แล้วคืน path ที่เอาไปแนบกับ
 * /api/public/checkout ได้เลย
 *
 * ไม่ throw — คืน { error } ให้ผู้เรียกโชว์ข้อความแล้วหยุด flow เอง
 */
export async function uploadSlipPublic(file: File): Promise<SlipUploadResult> {
  try {
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch('/api/public/upload-slip', { method: 'POST', body: fd });
    const data = await res.json().catch(() => null);
    if (!res.ok || !data?.url) {
      return { error: data?.error || 'อัพโหลดสลิปไม่สำเร็จ กรุณาลองใหม่' };
    }
    return { url: data.url as string };
  } catch {
    // เน็ตหลุดกลางทาง — ต้องบอกลูกค้า ไม่ใช่ปล่อยให้ปุ่มค้าง
    return { error: 'อัพโหลดสลิปไม่สำเร็จ กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่' };
  }
}
